import { z } from 'zod';

export type Protocol = `http${'' | 's'}`;
export type FullProtocol = `${Protocol}://`;

export type UrlWithoutProtocol = `${string}.${string}.${string}` | `${string}.${string}`;

export type Url = `${FullProtocol}${UrlWithoutProtocol}` | UrlWithoutProtocol;

export const establishUrlProtocol = (url: Url, defaultProtocol?: Protocol): Url => {
  if (url.startsWith('https://') || url.startsWith('http://')) {
    return url;
  }
  const protocol = defaultProtocol ?? 'https';
  return `${protocol}://${url}`;
};

export type Path = `/${string}`;

/**
 * A typeguard that returns whether or not the provided value is a path, based solely on the type
 * definition of {@link Path}.  This means that the only condition that is checked is whether or
 * not the provied value, {@link string}, begins with a forward-slash.
 *
 * This typeguard should not be used for validating that the form of the path is valid, outside of
 * whether or not the path begins with a forward slash.
 */
export const isPath = (path: string): path is Path => path.startsWith('/');

export const PathSchema = z.custom<Path>(value => typeof value === 'string' && isPath(value));
